import DocumentTitle from 'react-document-title';
import chroma from 'chroma-js';
import Radium from 'radium';
import React from 'react';
import { Link } from 'react-router';

import ReindexTypography from './ui/_ReindexTypography';

const { fontSizeToPx, rhythm } = ReindexTypography;

const headingStyle = fontSizeToPx('250%');
const styles = {
  codeAlt: {
    color: '#666',
  },
  paragraph: {
    maxWidth: '72ex',
  },
  testimonials: {
    marginBottom: rhythm(2),
    display: 'flex',
  },
  testimonial: {
    flexShrink: 0,
    '@media (max-width: 800px)': {
      flexShrink: 1,
      margin: `0 ${rhythm(2)}`,
    },
  },
  testimonialText: {
    position: 'relative',
    margin: `0 auto ${rhythm(1.5)}`,
    width: '60ex',
    padding: 50,
    '@media (max-width: 800px)': {
      width: 'auto',
    },
  },
  testimonialHighlight: {
    fontWeight: 'bold',
    color: 'rgba(0, 0, 0, 0.6)',
    ...fontSizeToPx('120%'),
  },
  triangle: {
    borderWidth: '15px 15px 0',
    borderStyle: 'solid',
    borderColor: 'whitesmoke transparent',
    display: 'block',
    width: 0,
    position: 'absolute',
    bottom: -15,
    left: 50 + (60 / 2) - 15,
  },
  testimonialQuote: {
    backgroundColor: 'transparent',
    color: chroma('#3cd8ff').alpha(0.75).css(),
    margin: 50,
    ...fontSizeToPx('300%'),
    '@media (max-width: 800px)': {
      display: 'none',
    },
  },
  recommender: {
    margin: '0 auto',
    paddingLeft: 50,
    display: 'flex',
    alignItems: 'center',
  },
  recommenderPicture: {
    borderRadius: '50%',
    width: 64,
    height: 64,
    margin: '0 20px 0 0',
  },
  recommenderInfo: {
    marginLeft: '1em',
    display: 'block',
  },
  textRhythm: {
    marginLeft: rhythm(1),
    marginRight: rhythm(1),
  },
};

@Radium
export default class Index extends React.Component {
  render() {
    return (
      <DocumentTitle title="Reindex">
        <div>
          <header
            style={{
              minHeight: 480,
              marginTop: rhythm(-1.5),
              textAlign: 'center',
              color: 'white',
            }}>
            <div style={{
              width: 800,
              maxWidth: '80%',
              margin: `0 auto ${rhythm(2)}`,
            }}>
              <div
                style={{
                  height: 0,
                  paddingBottom: `${100 * 480 / 800}%`,
                  paddingTop: rhythm(2),
                  margin: 0,
                  backgroundImage: 'url(/illustration_2017.svg)',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center bottom',
                  backgroundSize: '100% auto',
                }} />
            </div>
            <h1
              style={{
                ...headingStyle,
                textAlign: 'center',
                margin: 0,
                paddingBottom: rhythm(2),
                fontWeight: 200,
              }}>
              Web, Mobile and Beyond
            </h1>
          </header>
          <div style={{
            textAlign: 'center',
            paddingBottom: rhythm(1),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <div style={{ maxWidth: '70ex', ...styles.textRhythm }}>
              <p style={{ textAlign: 'center' }}>
                We create tools that
                change how developers
                build mobile apps and websites.
              </p>
              <p style={{ textAlign: 'center' }}>
                We're a team of software engineers focused on
                GraphQL, React.js and related open source
                technologies. <Link to="/team/">Read more.</Link>
              </p>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./index.jsx
 **/